import { motion } from "framer-motion";

const steps = [
  {
    n: "01",
    title: "Discovery call",
    desc: "A quick, friendly chat about your business, goals and budget. We listen first.",
  },
  {
    n: "02",
    title: "Design & build",
    desc: "We craft your website, branding and profiles — and share progress along the way.",
  },
  {
    n: "03",
    title: "Launch & grow",
    desc: "You go live with everything set up, plus the support to keep growing.",
  },
];

export default function Process() {
  return (
    <section id="process" className="bg-[#F0F5F2] py-24 sm:py-32">
      <div className="mx-auto max-w-6xl px-6 sm:px-12">
        <div className="max-w-2xl">
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-[#75C69F]">
            How it works
          </span>
          <h2 className="mt-4 font-heading text-4xl font-medium tracking-tight text-[#0B281B] sm:text-5xl">
            Simple, from hello to launch.
          </h2>
        </div>

        <div className="mt-14 grid gap-6 md:grid-cols-3">
          {steps.map((s, i) => (
            <motion.div
              key={s.n}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.12 }}
              data-testid={`process-step-${i}`}
              className="relative rounded-3xl bg-white border border-[#DCECE3] p-8"
            >
              <span className="font-heading text-6xl font-bold text-[#98D8BA]">
                {s.n}
              </span>
              <h3 className="mt-4 font-heading text-2xl font-medium text-[#0B281B]">
                {s.title}
              </h3>
              <p className="mt-3 text-[#4A6657]">{s.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
